<!-- 内容表现 -->
<template>
  <!-- 传播表现 -->
  <div class="ExpressionContainer block-wrap">
    <!-- <el-tabs v-model="portraitName" @tab-click="expressionTabClick">
      <el-tab-pane label="个人视频" name="个人视频">
      </el-tab-pane>
      <el-tab-pane label="星图视频" name="星图视频">
      </el-tab-pane>
    </el-tabs> -->
    <div class="part1">
      <div class="top">
        <div>
          <h5>数据概览</h5>
          <i>时间范围: {{tab1Position==="day30"?timeInfo.day_30:timeInfo.day_90}} ~ {{timeInfo.day_1}}</i>
        </div>
        <div>
          <span v-if="portraitName1 == '星图视频'" style="margin-right: 10px;">
            <el-checkbox v-model="flowType1" :true-label="1" :false-label="0"
             style="margin-right: 8px;" @change="() => expressionTabClick(portraitName1,1)"><span>排除营销流量</span>
            </el-checkbox>
            <el-checkbox v-model="isOnlyAssign1" :true-label="1" :false-label="0"
             style="margin-right: 8px;" @change="() => expressionTabClick(portraitName1,1)"><span>仅看指派视频</span>
            </el-checkbox>
          </span>
          <el-radio-group size="mini" class="tab clear" v-model="portraitName1" @change="e=>{expressionTabClick(e,1)}">
            <el-radio-button label="个人视频">个人视频</el-radio-button>
            <el-radio-button label="星图视频">星图视频</el-radio-button>
          </el-radio-group>
          <el-radio-group size="mini" class="tab clear" v-model="tab1Position" @change="tabDayClick">
            <el-radio-button label="day30">近30天</el-radio-button>
            <el-radio-button label="day90">近90天</el-radio-button>
          </el-radio-group>
        </div>

      </div>
      <div v-loading="loadingObj.part1data">
        <ul class="clear">
            <li>
                <p>播放量中位数</p>
                <span>{{((!part1data.play_mid)||part1data.play_mid==='NaN')?'-':part1data.play_mid}}</span>
                <p>超越<u> {{((!part1data.interact_rate1)||part1data.interact_rate1==='NaN')?'-':part1data.play_mid_rate1}}% </u>同类型达人</p>

            </li>
            <li>
                <p>完播率</p>
                <span>{{((!part1data.play_over_rate)||part1data.play_over_rate==='NaN')?'-':part1data.play_over_rate}}%</span>
                <p>超越<u> {{((!part1data.play_over_rate1)||part1data.play_over_rate1==='NaN')?'-':part1data.play_over_rate1}}% </u>同类型达人</p>
            </li>
            <li>
                <p>互动率</p>

                <span>{{((!part1data.interact_rate)||part1data.interact_rate==='NaN')?'-':part1data.interact_rate}}%</span>
                <p>超越<u> {{((!part1data.interact_rate1)||part1data.interact_rate1==='NaN')?'-':part1data.interact_rate1}}% </u>同类型达人</p>
            </li>


        </ul>
        <ul class="clear">
            <li>
                <p>发布作品</p>
                <!-- <span>{{part1data.item_num}}个</span> -->
                <span>{{((!part1data.item_num)||part1data.item_num==='NaN')?'-':part1data.item_num}}个</span>
            </li>
            <li>
                <p>平均时长</p>
                <!-- <span>{{part1data.avg_duration}}s</span> -->
                <span>{{((!part1data.avg_duration)||part1data.avg_duration==='NaN')?'-':(part1data.avg_duration/100).toFixed(1)}}s</span>
            </li>
            <li>
                <p>平均点赞</p>
                <!-- <span>{{part1data.like_avg}}</span> -->
                <span>{{((!part1data.like_avg)||part1data.like_avg==='NaN')?'-':part1data.like_avg}}</span>
            </li>
            <li>
                <p>平均评论</p>
                <!-- <span>{{part1data.comment_avg}}</span> -->
                <span>{{((!part1data.comment_avg)||part1data.comment_avg==='NaN')?'-':part1data.comment_avg}}</span>
            </li>
            <li>
                <p>平均转发</p>
                <!-- <span>{{part1data.share_avg}}</span> -->
                <span>{{((!part1data.share_avg)||part1data.share_avg==='NaN')?'-':part1data.share_avg}}</span>
            </li>
        </ul>
        <div class="top">
          <div>性价比/效果预估</div>
          <div class="searchForm">
            <el-checkbox v-model="commerceSpreadSearchForm.flowType" :disabled="commerceSpreadSearchForm.videoType=='图文'" :true-label="1" :false-label="0"
             style="margin-right: 8px;" @change="() => onSearchCommerceSpreadInfo(commerceSpreadSearchForm.flowType, 'flowType')"><span>排除营销流量</span>
            </el-checkbox>
            <span>视频类型：</span>
            <el-select v-model="commerceSpreadSearchForm.videoType" size="small" @change="() => onSearchCommerceSpreadInfo(commerceSpreadSearchForm.videoType, 'videoType')">
                <template #default>
                    <el-option style="padding: 0 20px" label="1-20s视频" value="1-20"></el-option>
                    <el-option style="padding: 0 20px" label="20-60s视频" value="20-60"></el-option>
                    <el-option style="padding: 0 20px" label="60s以上视频" value="60"></el-option>
                    <el-option style="padding: 0 20px" label="图文" value="图文"></el-option>
                </template>
            </el-select>
          </div>
        </div>
        <ul class="clear">
            <li>
                <p>预期CPM</p>
                <span>{{ commerceSpreadDataView.cpm }}</span>
            </li>
            <li>
                <p>预期CPE</p>
                <span>{{ commerceSpreadDataView.cpe }}</span>
            </li>
            <li>
                <p>预期播放量</p>
                <span>{{  commerceSpreadDataView.vv  }}</span>
            </li>
            <li>
                <p>爆文率</p>
                <span>{{ commerceSpreadDataView.platformHotRate }}</span>
            </li>
        </ul>
      </div>
      <div v-loading="loadingObj.part2data">
        <div class="top top1" >
          <div class="topLeft" >
            <p>{{part2data.title}}</p>
          </div>
          <div >
            <span v-if="portraitName2 == '星图视频'" style="margin-right: 10px;">
              <el-checkbox v-model="flowType2" :true-label="1" :false-label="0"
              style="margin-right: 8px;" @change="() => expressionTabClick(portraitName2,2)"><span>排除营销流量</span>
              </el-checkbox>
              <el-checkbox v-model="isOnlyAssign2" :true-label="1" :false-label="0"
              style="margin-right: 8px;" @change="() => expressionTabClick(portraitName2,2)"><span>仅看指派视频</span>
              </el-checkbox>
            </span>
            <el-radio-group size="small" class="tab clear" v-model="portraitName2" @change="e=>{expressionTabClick(e,2)}">
              <el-radio-button label="全部">全部</el-radio-button>
              <el-radio-button label="个人视频">个人视频</el-radio-button>
              <el-radio-button label="星图视频">星图视频</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <div>
             <div class="subtitle">最新15个视频中最低{{ tab2Position }} {{fmt(minVideoData/10000, {micrometer: true})+"w"||"-"}} 最高{{ tab2Position }} {{fmt(maxVideoData/10000, {micrometer: true})+"w"||'-'}}</div>
          </div>
          <div>
            <span style="margin-right:4px;display: inline-block;width: 12px;height: 12px;background-color: #3da3ff;"></span><span style="font-size: 12px;margin-right: 12px;">个人视频</span>
            <span style="margin-right:4px;display: inline-block;width: 12px;height: 12px;background-color: #f8528a;"></span><span style="font-size: 12px;margin-right: 4px;">星图视频</span>
            <el-radio-group size="small" class="tab clear" v-model="tab2Position" @change="part1Tab2">
               <el-radio-button label="播放量" name="播放量">播放量</el-radio-button>
               <el-radio-button label="点赞量" name="点赞量">点赞量</el-radio-button>
               <el-radio-button label="评论量" name="评论量">评论量</el-radio-button>
               <el-radio-button label="转发量" name="评论量">转发量</el-radio-button>
             </el-radio-group>
          </div>
        </div>
        <BarChart2 :barChart2Info="videoData" ref="videoChart" @xAxisClick="testXAxisClick"></BarChart2>
      </div>
    </div>
    <div class="part1">
      <div class="top">
        <h5>内容类型分析</h5>
      </div>
      <div class="authorVideo_pie" v-loading="loadingObj.getAuthorVideodist">
        <Pie :info="authorVideoPie"></Pie>
      </div>
    </div>
    <div class="hotWordBox">
      <div class="topTitle">
        <h5 class="chatTitle">热词分析</h5>
          <el-radio-group size="mini" class="tab clear" v-model="hotTabs">
            <el-radio-button label="评论热词" name="评论热词">评论热词</el-radio-button>
            <el-radio-button label="内容热词" name="内容热词">内容热词</el-radio-button>
          </el-radio-group>
      </div>
      <div class="chart" v-loading="loadingObj.getHotWord">
        <div class="chartItem">
          <el-dropdown v-if="hotTabs=='内容热词'" trigger="click" @command="contentTagsClick">
                <span class="el-dropdown-link">
                  {{ "内容标签:"+contentTagsData.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in contentTags" :command="item" :key="index">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          <div class="wordCloud">
            <WordCloud :info="wordCloud"></WordCloud>
          </div>
        </div>
        <div class="chartItem">
          <BarChart :barChartInfo="hotwordEchartData" ref="part2Chart"></BarChart>
        </div>
      </div>
    </div>
    <div class="part2" id="expression-video-wrap">
      <div class="top">
        <h5>视频内容</h5>
        <el-radio-group size="mini" class="tab clear" v-model="portraitName3" @change="e=>{expressionTabClick(e,3)}">
          <el-radio-button label="全部">全部</el-radio-button>
          <el-radio-button label="个人视频">个人视频</el-radio-button>
          <el-radio-button label="星图视频">星图视频</el-radio-button>
        </el-radio-group>
      </div>
      <div class="noDataBox" v-if="loadingObj.isViedoContent==false && !viedoContent[portraitName3]?.length ">
        <img src="../Cooperation/images/icon_none.png" alt="">
        <u class="noData">暂无数据</u>
      </div>
      <ul v-else class="clear" v-loading="loadingObj.isViedoContent">
        <li v-for="(item,i) in viedoContent[portraitName3]" :key="i">
          <div class="video" @click="videoClick(item)" @mouseenter="videoMove" @mouseleave="videoOut">
            <div class="videoWrap"></div>
            <video muted :src="item.video_id" :vindex="i" :poster="item.img_id" preload="none"></video>
          </div>
          <p>{{item.title}}</p>
          <div class="tag">
            <i></i>
            <span>{{item.play}}</span>
            <i></i>
            <span>{{item.like}}</span>
            <i></i>
            <span>{{item.comment}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="alertShow.isShow" class="alertVideo" @click="closeClick">
      <div class="close" @click="closeClick"></div>
      <div class="videoCard" @click.stop>
        <div class="videoBox">
          <video autoplay controls loop :src="alertShow.src"></video>
        </div>
        <div class="videoInfo">
          <div class="videoInfoTop">
            <div class="photo"><img :src="darenInfo.avatar_uri" alt=""></div>
            <div class="name">
              <p> {{darenInfo.nick_name}}</p>
              <i>粉丝数</i><b>{{darenInfo.follower}}</b>
            </div>
          </div>
          <div class="tag" v-for="(item,i) in darenInfo.tags_relation" :key="i">
            <span>{{i}}</span>
            <!-- <span>时尚是</span>
            <span>时尚</span> -->
          </div>
          <div class="hr"></div>
          <p> {{currentClick.title}} </p>
          <div class="other">
            <i></i><b>{{currentClick.play}}</b>
            <i></i><b>{{currentClick.like}}</b>
            <i></i><b>{{currentClick.comment}}</b>
          </div>
        </div>
        <div class="bottom">
          <span  style="color:black;margin-left:0;margin-right: auto;font-size: 12px;">
            发布时间：{{currentClick.create_time }}
          </span>
          <a :href="currentClick.url" target="_blank">打开视频</a>
          <i v-clipboard:copy="currentClick.url" v-clipboard:success="onCopy">复制链接</i>
          <!-- <a href="javascript:void(0);" @click="copyUrl">复制链接</a> -->
        </div>

      </div>
    </div>
    <!-- 相似达人模块-->
    <!-- <div class="part6" v-if="isShowSamedaren">
          <div class="bottemList">
            <div class="title">
                <div class="titleLeft"><i>{{darenName?darenName:''}}</i> 内容相似达人推荐</div>
                <div style="display:none;" class="titleRight"><i class="reflesh"></i>刷新一下</div>
            </div>
            <ul class="sameList">
                <li v-for="(item,i) in sameDaren" :key="i">
                    <a :toHref="item.author_id" href="javascript:void(0);" @click="sameListClick">
                        <div class="top">
                            <div class="nameWrap">
                                <span>{{item.nick_name}}</span>
                                <div></div>
                                <i v-for="(u,v) in item.tags_content" :key="v">{{u}}</i>
                            </div>
                            <div class="imgWrap">
                                <img :src="item.avatar_uri" alt="">
                            </div>
                        </div>
                        <div class="center">
                            <div class="centerItem">
                                <span>{{(item.follower/10000).toFixed(1)}}w</span>
                                <p>粉丝数</p>
                            </div>
                            <div class="centerItem">
                                <span>{{item.expected_cpm}}</span>
                                <p>预期CPM</p>
                            </div>
                            <div class="centerItem">
                                <span>{{(item.author_score/10000).toFixed(1)}}</span>
                                <p>星图指数</p>
                            </div>
                        </div>
                        <div class="tag">
                            <span v-for="(x,b) in item.recommend_types" :key="b">{{x}}</span>
                        </div>
                        <div class="hr"></div>
                        <div class="bottem">
                            <span class="price">￥{{item.min_price}}</span>
                            <div class="other">
                                <i></i>详情
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div> -->
  </div>
</template>

<script>
import BarChart from '../../../components/Echart/BarChart.vue';
import BarChart2 from '../../../components/Echart/BarChart2.vue';
import WordCloud from "../../../components/newEchart/WordCloud.vue";
import Pie from "../../../components/newEchart/Pie.vue";
import { apiCache } from "@/utils/index.js"
export default {
  name: "Expression",
  props:['darenName'],
  data(){
    return {
      authorVideoPie:{},
      wordCloud: {},
      flag2:false,//音频
      flag1:true,
      pageGetDarenItems:{},
      pageDarenInfo:{},
       //相似达人
      // sameDaren:{},
      // isShowSamedaren:false,
      // pageSameDarenRec:{},
      darenID:'',
        //时间
      timeInfo:{
          day_1:'',
          day_7:'',
          day_30:'',
          day_90:''
      },
      //达人播放数据
      darenInfo:{},
      darenItems:{},
      alertShow:{
        isShow:false,
        src:''
      },
      isOnlyAssign1: 1,
      flowType1: 0,
      isOnlyAssign2: 0,
      flowType2: 0,
      portraitName1:"个人视频",
      portraitName2:"全部",
      portraitName3:"全部",
      tab1Position:"day30",
      tab2Position:"播放量",
      videoData:{
          nodeId:'videoChart',//节点
          data: [0],//数据
          xAxisData:['-'],
          coverData:[''],
          min:0, //y轴的最小值
          max:180, //y轴最大值
          interval:30, //值之间的间隔
          yAxisName: '播放量',
          unit:' ',
          triggerEvent: true,
          emphasis: {show:false }
      },
      part3LiData:[],
      viedoContent:[],
      part1data:{
        play_over_rate:'-',
        play_over_rate1:'-',
        interact_rate:'-',
        interact_rate1:'-',
        play_mid:'-',
        item_num:'-',
        avg_duration:'-',
        like_avg:'-',
        comment_avg:'-',
        share_avg:'-'
      },
      part2data:{
        title:'最新15个视频表现柱状图',
        title2:{
          span1:'最新视频中最低转发量',
          span1Data:0,
          span2:'最高转发量',
          span2Data:0,
          span3:'最高转发量',
          span3Data:0,
        }
      },
      part3data:{

      },
      paramsData:[],
      currentClick:{},
      // contentDistributionChartInfo:{
      //     nodeId:'contentDistributionChart',//节点
      //     data:[]
      // },
      //达人热词
      hotWord:{},
      hotwordEchartData:{//近30天评论热词
        nodeId:'hotwordEchart',//节点
        data: [],//数据
        color:["#ff5c00","#40a0fc"],
        xAxisData:[],
        min:0, //y轴的最小值
        max:500, //y轴最大值
        interval:100, //值之间的间隔
        yAxisName: '评论数',
        tooltipName:'评论数',
        unit:''//单位
      },
      hotTabs:"评论热词",
      contentTagsData:{id:0,name:'不限'},
      contentTags:[
        {id:0,name:'不限'},
        {id:1,name:'品牌'},
        {id:2,name:'产品'},
        {id:3,name:'角色'},
        {id:4,name:'场景卖点'},
        {id:5,name:'痛点'},
        {id:6,name:'机构'},
        {id:7,name:'地理信息'},
        {id:8,name:'元素成分'},
      ],
      maxVideoData:0,
      minVideoData:0,
      loadingObj: {
        getHotWord: false,
        part2data: false,
        viedoContent:false,
        getAuthorVideodist: false,
        part1data: false
      },
      type:2,
      copyData:[],
      commerceSpreadSearchForm: {
        videoType: '1-20',
        flowType: 0,
      },
      commerceSpreadData: null,
      commerceSpreadDataView: {
        cpm:'',
        cpe:'',
        vv:'',
        platformHotRate: ''
      }
    }
  },
  computed:{

  },
  methods:{
    contentTagsClick(val){
      this.contentTagsData = val
      this.getHotContent(false)
    },
    async getHotWord(){
      this.loadingObj.getHotWord = true
      //   获取达人热评词
      if(window.sessionStorage.getItem('getHotWord')){
          this.handleHotWord()
      }else{
        await this.$api.getData.getHotWord('/'+this.darenID, false).then((res) => {
          window.sessionStorage.setItem('getHotWord',JSON.stringify(res));
          this.handleHotWord()
          this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
        })
      }
      this.loadingObj.getHotWord = false
    },
    getHotContent(updateBarChart = true){
      this.loadingObj.getHotWord = true
      this.$api.getData.getHotContent(`/${this.darenID || this.$route.query.id}?keyword_type=${this.contentTagsData.id}`, false).then((res) => {
          let data = res.data.data
          let arr = []
          let arr1 = []
          for (const key in data?.keyword_item_distribution) {
            let obj = data?.keyword_item_distribution
            arr.push({name:key,value:obj[key]})
          }
          for (const key in data?.keyword_map) {
            let obj = data?.keyword_map
            arr1.push({name:key,value:obj[key]})
          }
          arr.sort((a,b)=>b.value - a.value)
          if(updateBarChart) {
            this.hotwordEchartData.xAxisData = arr?.map(x=>x.name)
            this.hotwordEchartData.data = arr?.map(x=>x.value)
            this.hotwordEchartData.min = 0
            this.hotwordEchartData.yAxisName = '内容数',
            this.hotwordEchartData.tooltipName = '内容数'
            this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
          }
          let colors = ['#FF5500','#FF5C00','#FFA555','#38A1FF']
          this.wordCloud.data = arr1?.map((x, i) => {
            return {name:x.name,value:x.value,color:colors[i]}
          })
        }).finally(() => {
          this.loadingObj.getHotWord = false
        })
    },
    handleHotWord(){
        //   获取达人热评词
        let data = JSON.parse(window.sessionStorage.getItem('getHotWord')).data.data
        // this.hotWord = data.hot_comment_tokens
        let hotTokens = data
        this.hotWord = hotTokens

        this.wordCloud = {
          name: '分类热评词',
          data: [],
          }
          if(hotTokens){
            let colors = ['#FF5500','#FF5C00','#FFA555','#38A1FF']
            hotTokens?.forEach((x,i)=>{
            this.wordCloud.data.push({name:x.comment_token,value:x.hot_rate,color:colors[i]})
          })
        }
        let hotwordEchartData = {
            nodeId:'hotwordEchart',//节点
            data: [],//数据
            color:["#ff5c00","#40a0fc"],
            xAxisData:[],
            min:0, //y轴的最小值
            max:500, //y轴最大值
            interval:100, //值之间的间隔
            yAxisName: '评论数',
            tooltipName:'评论数',
            unit:''//单位
        }
        hotTokens?.forEach(function(item,i){
            if(i<5){
                hotwordEchartData.xAxisData.push(item.comment_token)
                hotwordEchartData.data.push(item.hot_rate)
            }
        })
        hotwordEchartData.max = (Math.max.apply(null,hotwordEchartData.data)/100).toFixed(0)*100
        hotwordEchartData.interval = (hotwordEchartData.max-hotwordEchartData.min)/5
        this.hotwordEchartData = hotwordEchartData
    },
    sameListClick(e){
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
        let routeData = this.$router.resolve({
            path: '/daren',
          query: {
              id: e.currentTarget.getAttribute("tohref")
          }
        })
        window.open(routeData.href, "_blank");
    },
    changeW(num){
       return (num/10000).toFixed(1)
    },
    tabDayClick(tab){
      this.tab1Position===tab
      this.changeData(this.tab1Position,this.portraitName1)
    },
    part1Tab2(tab){
      this.tab2Position=tab
      // if(tab==="播放量"){
      // }else if(tab==="点赞量"){

      // }else if(tab==="评论量"){

      // }else if(tab==="转发量"){

      // }
      this.changeChart()
    },
    expressionTabClick(tab,type){
      this.type = type
      // if(tab==="个人视频"){
      //   this['portraitName'+this.type]==="个人视频"
      // }else if(tab==="星图视频"){
      //   this['portraitName'+this.type]==="星图视频"
      // }
      if(type==1){
        this.changeData(this.tab1Position,this['portraitName'+this.type])
      }else if(type==2 || type==3){
        this.changeChart()
      }
      // if(tab==="个人视频"){
      //   this.portraitName==="个人视频"
      //   this.part2data.title="最新15个视频表现柱状图"
      // }else if(tab==="星图视频"){
      //   this.portraitName==="星图视频"
      //   this.part2data.title="最新15个视频表现柱状图"
      // }
      // this.changeData(this.tab1Position,this.portraitName)
      // this.changeChart(this.tab1Position,this.portraitName)
    },
    changeData(tab1Position,portraitName){
      let param = `type=${
        portraitName == '个人视频' ? 1 :
        portraitName == '星图视频' ? 2 : ''
      }&range=${
        tab1Position == 'day30' ? 2 :
        tab1Position == 'day90' ? 3 : ''
      }&only_assign=${
        portraitName == '星图视频' ? this.isOnlyAssign1 : ''
      }&flow_type=${
        portraitName == '星图视频' ? this.flowType1 : ''
      }`
      this.loadingObj.part1data = true
      this.$api.getData.getDarenSpread('/'+this.darenID,param).then((res) => {
        this.chooseGetDarenSpread(res.data.data)
      }).finally(()=>{
        this.loadingObj.part1data = false
      })

    },
    chooseGetDarenSpread(data){
        this.part1data.play_over_rate=data.play_over_rate.value/100
        this.part1data.play_over_rate1=data.play_over_rate.overtake/100
        this.part1data.interact_rate=data.interact_rate.value/100
        this.part1data.interact_rate1=data.interact_rate.overtake/100

        // 播放量中位数
        let play_mid = data.item_rate.play_mid.value
        if(parseInt(play_mid)>=10000){
          play_mid = this.changeW(play_mid) +'w'
        }
        this.part1data.play_mid=play_mid
        this.part1data.play_mid_rate1 = data.item_rate.play_mid.overtake / 100

        this.part1data.item_num=data.item_num
        this.part1data.avg_duration=data.avg_duration
        if(parseInt(data.like_avg)>=10000){
          this.part1data.like_avg = this.changeW(data.like_avg) +'w'
        }else{
          this.part1data.like_avg=data.like_avg
        }
        if(parseInt(data.comment_avg)>=10000){
          this.part1data.comment_avg = this.changeW(data.comment_avg) +'w'
        }else{
          this.part1data.comment_avg=data.comment_avg
        }
        if(parseInt(data.share_avg)>=10000){
          this.part1data.share_avg = this.changeW(data.share_avg) +'w'
        }else{
          this.part1data.share_avg=data.share_avg
        }
    },
    async changeChart(){

      this.loadingObj.isViedoContent = true
      this.loadingObj.part2data = true
      const cacheKey = `author-items:/${this.darenID}?only_assign=${this.isOnlyAssign2}&flow_type=${this.flowType2}`
      const res = await apiCache(cacheKey,()=> this.$api.getData.getDarenItems(`/${this.darenID}?only_assign=${this.isOnlyAssign2}&flow_type=${this.flowType2}`, false))
      const videoListData = this._.cloneDeep(res.data.data)
      console.log('videoListData :>> ', videoListData);
      res.data.data.latest_item_info.forEach((item, index)=>{
        item._videoType_ = '个人视频'
      })
      res.data.data.latest_star_item_info.forEach((item, index)=>{
        item._videoType_ = '星图视频'
      })

      this.pageGetDarenItems = res.data.data
      this.changeChartData()
      this.videoData.data.reverse()
      this.maxVideoData = Math.max.apply(null,this.videoData.data.reverse())
      this.minVideoData = Math.min.apply(null,this.videoData.data.reverse())
      this.videoData.xAxisData.reverse()
      this.$refs.videoChart.barChart2(this.videoData)
      this.loadingObj.part2data = false
      this.loadingObj.isViedoContent = false
      let { latest_item_info = [], latest_star_item_info = [] } = videoListData
      latest_item_info = latest_item_info.map(item => {
        const videoItem =  this.formatVideoItem(item);
        videoItem._videoType_ = '个人视频'
        return videoItem
      })
      latest_star_item_info = latest_star_item_info.map(item => {
        const videoItem =  this.formatVideoItem(item);
        videoItem._videoType_ = '星图视频'
        return videoItem
      })
      this.viedoContent = {
        '个人视频': latest_item_info,
        '星图视频': latest_star_item_info,
        '全部': [...latest_item_info, ...latest_star_item_info].sort((a, b) => b.create_time - a.create_time)
      }

    },
    // ai
     changeChartData() {

        const _this = this;
        const data = this.pageGetDarenItems;
        this.darenItems = data;

        // 初始化数据容器
        const chartContainers = {
            chartData: [],
            coverData: [],
            xAxisData: [],
            cardTitle: [],
            part3LiData: [],
            viedoContent: [],
            timeData: [],
            is_hot: []
        }

        // 根据视频类型处理数据
        const videoType = this['portraitName' + _this.type];
        let videoSource = videoType === "个人视频" ? data?.latest_item_info :
            videoType === "星图视频"  ? data?.latest_star_item_info :
            videoType == '全部' ? [...data?.latest_item_info, ...data?.latest_star_item_info ] :
            []

        if (!videoSource) return;
        // 排序处理
        videoSource.sort((a, b) => b.create_time - a.create_time);
        videoSource = videoSource.slice(0,15)

        // 设置图表需要的视频内容数据
        videoSource.forEach((item) => {
            const videoItem = this.formatVideoItem(item);
            chartContainers.part3LiData.unshift(videoItem);
            chartContainers.coverData.unshift(videoItem.img_id);
        });
        // 处理图表数据
        this.processChartData(videoSource, chartContainers);

        // 更新组件状态
        this.part3LiData = chartContainers.part3LiData;

    },
    // 格式化单个视频项
    formatVideoItem(item) {
        const videoItem = {
            item_date: item.item_date,
            create_time: this.dayjs(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss"),
            title: item.title,
            comment: item.comment,
            play: item.play,
            like: item.like,
            url: item.url,
            video_id: 'https://aweme.snssdk.com/aweme/v1/playwm/?video_id=' + item.video_id + '&ratio=720p&line=0',
            img_id: 'https://p3-tt.bytecdn.cn/obj/' + item.item_animated_cover,
            is_hot: item.is_hot,
            _videoType_: item._videoType_,
        };

        // 数值格式化
        ['like', 'play', 'comment'].forEach(key => {
            if (videoItem[key] >= 10000) {
                videoItem[key] = (videoItem[key] / 10000).toFixed(1) + 'w';
            }
        });

        return videoItem;
    },
    // 处理图表数据
    processChartData(videoSource, containers) {
        const metricMap = {
            "播放量": "play",
            "点赞量": "like",
            "评论量": "comment",
            "转发量": "share"
        };
        const metricNames = {
            "play": "播放量",
            "like": "点赞量",
            "comment": "评论量",
            "share": "转发量"
        };
        const metricKey = metricMap[this.tab2Position];
        if (!metricKey) return;

        videoSource.forEach((item) => {
            containers.is_hot.unshift(item.is_hot);
            containers.cardTitle.unshift(item.title);

            if (item?.create_time) {
                containers.timeData.unshift(this.dayjs(item.create_time * 1000).format("YYYY-MM-DD HH:mm:ss") || "");
                containers.xAxisData.push(this.dayjs(item.create_time * 1000).format("MM-DD HH:mm") || "");
            }

            containers.chartData.push(item[metricKey]);
        });

        // 更新图表配置
        const colorMap = {
          '个人视频': '#3da3ff',
          '星图视频': '#f8528a',
        }
        this.videoData.barColor = (params)=>{
          // todo 测试用this.part3LiData作为数据依据
          return colorMap[this.part3LiData[params.dataIndex]._videoType_]
        }
        this.videoData.data = containers.chartData;
        this.videoData.coverData = containers.coverData;
        this.videoData.xAxisData = containers.xAxisData;
        this.videoData.yAxisName = metricNames[metricKey];
        this.videoData.unit = '';
        this.videoData.is_hot = containers.is_hot;

        // 计算坐标轴范围
        this.videoData.max = Math.max.apply(null, containers.chartData);
        this.videoData.min = Math.min.apply(null, containers.chartData);
        this.videoData.interval = parseInt((this.videoData.max - this.videoData.min) / 4);

        // 设置悬浮提示
        let metricName = metricNames[metricKey];
        this.videoData.formatter = (params) => {
            const cur = params[0];
            const value = containers.chartData[cur.dataIndex]
                ? (containers.chartData[cur.dataIndex] / 10000).toFixed(2)
                : '-';

            return `
                    <div style="display:flex;justify-content: space-between;">
                        <img src="${containers.coverData[cur.dataIndex]}" style="width:60px;margin-right:10px"/>
                        <div style="display: flex;flex-direction:column;justify-content: space-between;">
                        <div style="display: block;width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                            ${containers.cardTitle[cur.dataIndex]}
                        </div>
                        <div>${metricName}：${value}w</div>
                        <div>${containers.timeData[cur.dataIndex]}</div>
                        </div>
                    </div>
                    `;
        };
    },
    // ai .
    videoClick(item){
      this.alertShow.src= item.video_id
      this.currentClick = item
      this.alertShow.isShow=true
      console.log('currentClick :>> ', item);
      // this.alertShow.isShow=true
      // this.alertShow.src=e.target.src
      // this.currentClick = this.viedoContent[e.target.getAttribute("vindex")-0]
    },
    onCopy(){
      alert('复制链接成功')
    },
    closeClick(){
      this.alertShow.isShow=false
    },
    videoMove(e){
        e.currentTarget.firstElementChild.className="videoWrap active"
        e.currentTarget.lastElementChild.play()
    },
    videoOut(e){
      e.currentTarget.firstElementChild.className="videoWrap"
      e.currentTarget.lastElementChild.pause()
    },
    // create10(){
    //   this.sameDaren = this.pageSameDarenRec
    //   if(this.sameDaren){
    //       this.sameDaren.forEach(function(item){
    //           item.author_id =item.author_id
    //       })
    //       this.isShowSamedaren = true
    //   }
    // },
    getAuthorVideodist(){
      this.loadingObj.getAuthorVideodist = true
      this.$api.getData.getAuthorVideodist('/'+this.darenID).then((res) => {
        let data = res.data.data;
        let color = ['#1C7CFC','#3E92FF','#42A6FE','#73C2FF','#88CBFF']
        this.authorVideoPie = {
          name: '内容类型分析',
          showPercent:false,
          radius: ['45%', '60%'], // 格式：['40%', '70%']
          showLabelRate: 5, //比率大于百分之5的时候展示label
          data: [ ],
          custom: {
            legend: {
              show:false
            },
            series: [
              {
                label: {
                  show: true,
                  formatter: '{b}\n{d}%',
                }
              }
            ]
          }
        }
       this.authorVideoPie.data = data?.video_content_distribution?.map((x,i)=>{
        return {value: (Number(x.proportion)*100).toFixed(2), name:x.name, color:color[i]}
        })
      }).finally(()=>{
        this.loadingObj.getAuthorVideodist = false
      })
    },
    testXAxisClick(args) {
      this.alertShow.isShow=true
      this.alertShow.src = this.part3LiData[args.dataIndex].video_id
      this.currentClick = this.part3LiData[args.dataIndex]
      console.log('this.currentClick  :>> ', this.currentClick );
    },
    async fetchCommerceSpreadInfo(){
       let params = {
          o_author_id: this.darenID,
          route: 'get_author_commerce_spread_info'
        }
        const res = await this.$axios.get(`/author-aggregator`, { params })
        if (res?.data?.code === 0) {
          const data = res.data.data
          console.log('fetchCommerceSpreadInfo :>> ', data);
          this.commerceSpreadData = data
        }

    },
    async onSearchCommerceSpreadInfo(value, field) {
      if(this.commerceSpreadSearchForm.videoType == '图文'){
        this.commerceSpreadSearchForm.flowType = 0
      }
      if(!this.commerceSpreadData){
        await this.fetchCommerceSpreadInfo()
      }
      const data = this.commerceSpreadData
      const commerceSpreadDataView = {}
      const { videoType, flowType } = this.commerceSpreadSearchForm
      if(videoType == '1-20'){
        commerceSpreadDataView.cpm = flowType == 0 ? data.cpm_1_20 : data.sn_cpm_1_20
        commerceSpreadDataView.cpe = flowType == 0 ?  data.cpe_1_20 : data.sn_cpe_1_20
        commerceSpreadDataView.vv = flowType == 0 ? data.vv : data.sn_vv
      } else if(videoType == '20-60'){
        commerceSpreadDataView.cpm = flowType == 0 ? data.cpm_20_60 : data.sn_cpm_20_60
        commerceSpreadDataView.cpe = flowType == 0 ?  data.cpe_20_60 : data.sn_cpe_20_60
        commerceSpreadDataView.vv = flowType == 0 ? data.vv : data.sn_vv
      } else if(videoType == '60'){
        commerceSpreadDataView.cpm = flowType == 0 ? data.cpm_60 : data.sn_cpm_60
        commerceSpreadDataView.cpe = flowType == 0 ?  data.cpe_60 : data.sn_cpe_60
        commerceSpreadDataView.vv = flowType == 0 ? data.vv : data.sn_vv
      } else if(videoType == '图文'){
        commerceSpreadDataView.cpm = ''
        commerceSpreadDataView.cpe = ''
        commerceSpreadDataView.vv = data.vv
      }
      commerceSpreadDataView.cpm = (+(+commerceSpreadDataView?.cpm || 0)?.toFixed?.(1)) || '-'
      commerceSpreadDataView.cpe = (+(+commerceSpreadDataView?.cpe || 0)?.toFixed?.(1)) || '-'
      commerceSpreadDataView.vv = data.vv > 10000 ? (commerceSpreadDataView.vv/10000).toFixed(1) + 'w' : commerceSpreadDataView.vv
      commerceSpreadDataView.platformHotRate = data.platform_hot_rate ? (data.platform_hot_rate * 100) + '%' : '-'
      this.commerceSpreadDataView = commerceSpreadDataView
    },

  },
  components:{
    BarChart2,
    BarChart,
    WordCloud,
    Pie,
  },
  watch:{
    hotTabs:{
      handler(val){
        if(val == "内容热词"){
          this.getHotContent()
          this.contentTagsData = {id:0, name:"不限"}
        }else if(val == "评论热词"){
          this.getHotWord()
          this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
        }
      },
    },
  },
  created(){
    this.darenID = this.$route.query.id
    // part1
    this.changeData(this.tab1Position,this.portraitName1)
    //part2
    this.changeChart()


    this.getAuthorVideodist();

    // part3  获取达人基础信息

    if(window.sessionStorage.getItem('getDarenInfo')){
      this.pageDarenInfo= JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
      if(this.pageDarenInfo.follower>=10000){
          this.pageDarenInfo.follower=(this.pageDarenInfo.follower/10000).toFixed(1)+'w'
      }
      if(this.pageDarenInfo.gender===1){
          this.pageDarenInfo.gender='男'
      }else{
          this.pageDarenInfo.gender='女'
      }
      this.darenInfo = this.pageDarenInfo;
      this.timeInfo.day_1 = this.pageDarenInfo.day_1
      this.timeInfo.day_7 = this.pageDarenInfo.day_7
      this.timeInfo.day_30 = this.pageDarenInfo.day_30
      this.timeInfo.day_90 = this.pageDarenInfo.day_90
    }else{
        this.$api.getData.getDarenInfo('/'+this.darenID).then((res) => {
            window.sessionStorage.setItem('getDarenInfo',JSON.stringify(res));
            this.pageDarenInfo= JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
            if(this.pageDarenInfo.follower>=10000){
            this.pageDarenInfo.follower=(this.pageDarenInfo.follower/10000).toFixed(1)+'w'
            }
            if(this.pageDarenInfo.gender===1){
                this.pageDarenInfo.gender='男'
            }else{
                this.pageDarenInfo.gender='女'
            }
            this.darenInfo = this.pageDarenInfo;
            this.timeInfo.day_1 = this.pageDarenInfo.day_1
            this.timeInfo.day_7 = this.pageDarenInfo.day_7
            this.timeInfo.day_30 = this.pageDarenInfo.day_30
            this.timeInfo.day_90 = this.pageDarenInfo.day_90

            })
    }
  //  获取相似达人推荐
    // if(window.sessionStorage.getItem('getDarenCoope')){
    //     this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //     this.create10()
    // }else{
    //     this.$api.getData.getSameDarenRec('/'+this.darenID).then((res) => {
    //         window.sessionStorage.setItem('getSameDarenRec',JSON.stringify(res));
    //         this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
    //         this.create10()
    //     })
    // }
    this.getHotWord()

  },
  mounted() {
    let _this = this
    if(this.flag1){
      this.flag1=false
      this.videoData.data.reverse()
      this.videoData.xAxisData.reverse()
      this.$refs.videoChart.barChart2(this.videoData)
    }
    this.$refs?.part2Chart?.barChart(this.hotwordEchartData)
    // this.$refs.videoChart.barChart2(this.videoData)
        //监听键盘Esc按键事件
    this.$nextTick(function() {
      // 按下键盘
      document.addEventListener('keydown', function(e) {
        // Esc按键是27
        if (e.keyCode == 27) {
          //在这里写你的操作逻辑
          _this.closeClick()
        }
      });
    });

    this.onSearchCommerceSpreadInfo()
  }
}
</script>
<style lang="less" scoped>
    .el-dropdown-menu{
      width: 150px;
    // height: 350px;
      overflow: auto;
    }
    .el-dropdown-menu__item{
      padding-left:20px;
    }
    .searchForm{
      font-size: 14px;
    }
</style>

<style scoped>
  .noData{
    display: block;
    text-align: center;
    margin: 20px auto;
    color: #A1A1A1;
    padding-bottom: 30px;
  }
  .noDataBox img{
    display: block;
    margin: auto;
    padding-top: 30px;
  }
  .authorVideo_pie{
    width: 100%;
    height: 300px;
  }
  .wordCloud{
    margin-top: 40px;
    height: 168px;
  }
  .active{
    display: none;
  }
  i{
    font-style: normal;
  }
  li{
      padding:0;
      margin:0;
      list-style:none;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #eee;
  }
  #videoChart{
    margin-top: 10px;
    /* width: 804px; */
    height: 266px;
  }
  #contentDistributionChart{
    margin-top: 10px;
    /* width: 804px; */
    height: 266px;
  }
  .ExpressionContainer{
    /* width: 884px; */
  }
  .ExpressionContainer .part1{
    /* width: 864px; */
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .ExpressionContainer .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
  .ExpressionContainer .top h5{
    display: inline-block;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .ExpressionContainer .top .tab{
    margin-right: 10px;
    /* float: right; */
    /* margin-left: 16px;
    margin-top: 22px; */
  }

  .ExpressionContainer .part1 ul{
      width: 100%;
      height: 120px;
      margin: 0;
      padding: 30px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #F0F0F0;
  }
  .ExpressionContainer .part1 ul li{
      float: left;
      width: 20%;
      height: 100%;
      border-right: 1px solid #F0F0F0;
      list-style:none;
      text-align: center;
      box-sizing: border-box;
  }
  .ExpressionContainer .part1 ul:nth-of-type(1){
    height: 136px;
  }
  .ExpressionContainer .part1 ul:nth-of-type(1) li{
      width: 33%;
      height: 78px;
  }
  .ExpressionContainer .part1 ul li:nth-last-of-type(1){
      border: 0;
  }
  .ExpressionContainer .part1 ul li span{
      display: inline-block;
      margin-bottom: 6px;
      font-size: 18px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #333333;
  }
  .ExpressionContainer .part1 ul li p u{
    text-decoration: none;
    color: #FF5C00;
  }
  .ExpressionContainer .part1 ul li p{
      position: relative;
      margin-top: 4px;
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #666666;
      text-align: center;
  }
  .ExpressionContainer .part1 ul li p i{
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      margin-left: 6px;
      width: 14px;
      height: 14px;
      background: purple;
  }
  .ExpressionContainer .top1.top{
    border-bottom: 0;
  }
  .ExpressionContainer .top1.top h5{
    float: left;
    height: 100%;
    margin: 0;
    font-size: 14px;
    line-height: 76px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    bottom: 0;
  }

  .ExpressionContainer>>>.el-tabs__content{
    margin-top: 0 !important;
  }
  /* .ExpressionContainer>>>.el-tabs__nav-wrap::after{
    height: 0;
  }
  .ExpressionContainer>>>.el-tabs__nav-scroll{
    padding-left: 30px;
  } */
  .ExpressionContainer{
    width: 100%;
    /* margin-top:16px; */
    background: #FFFFFF;
    border-radius: 4px;
  }
  /* .ExpressionContainer>>>.el-tabs__item{
    line-height:74px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .ExpressionContainer>>>.el-tabs__active-bar{
    background:transparent!important;
  }
  .ExpressionContainer>>>.el-tabs__active-bar {
    height: 0!important;
  }  */
  .ExpressionContainer .top1 .topLeft{
    float: left;
    width: 40%;
  }
  .ExpressionContainer .top1 .topLeft p{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .top1 .topLeft span{
    display: inline-block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999;
  }
  .ExpressionContainer .top1 .topLeft i{
    display: inline-block;
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
    margin-right: 18px;
    margin-left: 6px;
  }
  .ExpressionContainer .part2{
    width: 100%;
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .ExpressionContainer .part2 h5{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .ExpressionContainer .part2 ul{
    width: 100%;
    min-height:500px;
    padding: 0;
    overflow: hidden;
  }
  .ExpressionContainer .part2 ul li{
    float: left;
    width: 248px;
    height: 488px;
    margin-right: 30px;
  }
  /* .ExpressionContainer .part2 ul li:nth-of-type(3n){
    margin-right: 0;
  } */
  .ExpressionContainer .part2 ul li .video{
    position: relative;
    width: 248px;
    height: 342px;
    background: #000000;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .ExpressionContainer .part2 ul li .video video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .ExpressionContainer .part2 ul li .video .videoWrap{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
  .ExpressionContainer .part2 ul li .video .videoWrap::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
    content: '';
    width: 31px;
    height: 35px;
    background: url("../images/icon_play.png") no-repeat center;
  }

  .ExpressionContainer .part2 ul li p{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
  }
  .ExpressionContainer .part2 ul li .tag i{
    display: inline-block;
    width: 11px;
    height: 11px;
    margin-right: 8px;
    background: url("../images/icon_1.png") no-repeat center;
  }
  .ExpressionContainer .part2 ul li .tag i:nth-of-type(1){
    width: 8px;
    height: 11px;
    background-image: url("../images/icon_3.png");
  }
  .ExpressionContainer .part2 ul li .tag i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .ExpressionContainer .part2 ul li .tag span{
    margin-right: 12px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #666666;
  }

  .alertVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0,0,0,.5);
  }
  .alertVideo .videoCard{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 8px;
    width: 820px;
    height: 646px;
    background: #fff;
    border-radius: 6px;
  }
  .alertVideo .videoCard .videoBox{
    position: relative;
    float: left;
    width: 363px;
    height: 644px;
    border-radius: 4px;
    overflow: hidden;
    background: #000000;
  }
  .alertVideo .videoCard .videoBox video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo{
    float: right;
    width: 390px;
    height: 100%;
    margin-right: 20px;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop{
    margin-top: 30px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo{
    float: left;
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo img{
    width: 100%;
    height: 100%;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name{
    float: left;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name p{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name i{
    display: inline-block;
    margin-right: 6px;
    color: #999;
    font-size: 14px;

  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name b{
    display: inline-block;
    color: #666;
    font-size: 14px;
  }
  .alertVideo .videoCard .videoInfo .tag{
    margin: 10px 0;
    overflow: hidden;
    display: inline-block;
  }
  .alertVideo .videoCard .videoInfo .tag span{
    float: left;
    color: #333;
    font-size: 14px;
    padding: 3px 8px;
    background: #eee;
    border-radius: 4px;
    margin-right: 8px;
  }
  .alertVideo .videoCard .videoInfo p{
    width: 100%;
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #333;
  }
  .alertVideo .videoCard .videoInfo .other{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo .other i{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 10px;
    line-height: 18px;
    background: url("../images/icon_7.png") no-repeat center bottom;
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(1){
    background-image: url("../images/icon_9.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(3){
    background-image: url("../images/icon_8.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other b{
    display: inline-block;
    margin-right: 20px;
    font-size: 16px;
    color: #333;
    line-height: 18px;
  }
  .alertVideo .close{
    position: absolute;
    top:40px;
    right: 40px;
    width: 21px;
    height: 21px;
    background: url("../images/close.png") no-repeat center;
    cursor: pointer;
  }
  .videoCard .bottom{
    position: absolute;
    bottom: 20px;
    right: 30px;
    display: flex;
    align-items: center;
    width: 390px;
  }
  .videoCard .bottom a,
  .videoCard .bottom i{
    display: inline-block;
    margin-left: 10px;
    color: #38a1ff;
    font-size: 12px;
    cursor: pointer;
  }
  /*达人推荐 */

  .ExpressionContainer .part6{
        margin-top: 16px;
    }

    .bottemList {
        width: 864px;
        padding: 0 28px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }

    .bottemList .title {
        width: 100%;
        height: 74px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        line-height: 74px;
    }

    .bottemList .title .titleLeft {
        float: left;
        height: 100%;
    }

    .bottemList .title .titleLeft i {
        color: #FF5500;
    }

    .bottemList .title .titleRight {
        position: relative;
        float: right;
        color: #666666;
        height: 100%;
    }

    .bottemList .title .titleRight .reflesh {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -22px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_updata.png");
    }

    .bottemList .sameList {
        width: 100%;
        margin-top: 0;
        padding: 0;
        overflow: hidden;
    }

    .bottemList .sameList .top {
        width: 100%;
        height: 54px;
        margin-bottom: 0;
        border: 0;
    }

    .bottemList .sameList li {
        float: left;
        width: 248px;
        height: 264px;
        margin-right: 30px;
        margin-bottom: 30px;
        padding: 24px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .bottemList .sameList li:hover {
        box-shadow:0px 0px 16px rgb(0, 0, 0, .2);
    }
    .bottemList .sameList li a{
        display: block;
    }
    .bottemList .sameList li:nth-of-type(3n) {
        margin-right: 0;
    }

    .bottemList .sameList .top .nameWrap {
        float: left;
        width: 70%;
    }

    .bottemList .sameList .top span {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .bottemList .sameList .top i {
        display: inline-block;
        margin-left: 0;
        margin-right: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .top .imgWrap {
        float: right;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        overflow: hidden;
    }

    .bottemList .sameList .top .imgWrap img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .bottemList .sameList .center {
        width: 100%;
        overflow: hidden;
    }

    .bottemList .sameList .center .centerItem {
        float: left;
        width: 37%;
        margin-top: 16px;
    }

    .bottemList .sameList .center .centerItem:nth-of-type(3) {
        width: 26%;
    }

    .bottemList .sameList .center .centerItem span {
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }

    .bottemList .sameList .center .centerItem p {
        margin-top: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .tag {
        border-radius: 2px;
        overflow: hidden;
        margin-top: 14px;
        margin-bottom: 14px;
    }

    .bottemList .sameList .tag span {
        background: #FFF2EB;
        float: left;
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 6px;
        padding: 0 10px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem {
        width: 100%;
        height: 20px;
        margin-top: 16px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem .price {
        float: left;
    }

    .bottemList .sameList .bottem .other {
        position: relative;
        float: right;
    }

    .bottemList .sameList .bottem .other i {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_comunication.png");
    }
    .ExpressionContainer .hotWordBox{
      padding: 0 30px;
    }
    .ExpressionContainer .hotWordBox .topTitle{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .chart {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .chart .chartItem{
        width: 50%;
    }
    .chart .chartItem:nth-of-type(2){
        border-right: 0;
    }
    .hotWordBox .chatTitle {
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
    }
    #hotwordEchart{
        margin-top: 20px;
        width: 402px;
        height: 254px;
    }
    .subtitle{
      color: #999;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
    }

</style>